module.exports = __webpack_public_path__ + "static/media/review.d34049a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/review.png
// module id = 2445
// module chunks = 0